module.exports = __webpack_public_path__ + "img/万达美好物业APP隐私协议3450.cb92bb5b.png";